export const SEARCH_METHODS = {
  PROVIDERS_BY_SPECIALTY: 'providersBySpecialty',
  PROVIDER_BY_ENTITY_ID: 'providerByEntityId',
  PROVIDERS_BY_ENTITY_IDS: 'providersByEntityIds',
  PROVIDERS_BY_NAME: 'providersByName',
  PROVIDERS_BY_AFFILIATION: 'providersByAffiliation',
  PROVIDERS_BY_LOCATION: 'providersByLocation',
  PLACES_BY_TYPE: 'placesByType',
  PLACES_BY_LOOSE_NAME: 'placesByLooseName',
  PLACE_BY_NAME_EXACT: 'placeByNameExact',
  PROVIDERS_BY_SERVICE: 'providersByService',
  PLACES_BY_SERVICE: 'placesByService',
  PLACE_BY_ID: 'placeById',
  PLACES_BY_ID: 'placesById',
} as const;

export type SearchMethod = (typeof SEARCH_METHODS)[keyof typeof SEARCH_METHODS];

export const ENDPOINTS = {
  AUTOCOMPLETE: '/autocomplete',
  PROVIDERS: '/providers',
  PLACES: '/places',
  SERVICE: '/service',
  SHARE: '/share',
  SPECIALTIES: '/specialties',
  CLOSEST_PROVIDERS: '/closest-provider-location',
  CLOSEST_PLACES: '/closest-place-location',
  REWARDS_CAMPAIGN: '/rewards-campaign',
  PROVIDER_COST: 'provider-cost',
  NETWORK_SELECT: '/analytics/network-select/',
  CLIENT_CONFIG: '/client-config/',
} as const;

export type FusionEndpoint = (typeof ENDPOINTS)[keyof typeof ENDPOINTS];

export const SEARCH_LIMIT: number = 50;

export const PARAMS = {
  LOCATION: 'location',
  LIMIT: 'limit',
  OFFSET: 'offset',
  ORDERING: 'ordering',
  NETWORK_SLUG: 'network_slug',
  RADIUS: 'radius',
  BOUNDING_BOX: 'bounding_box',
  ENTITY_TYPE: 'entity_type',
  Q: 'q',
  SPECIALTY_ID: 'specialty_id',
  SUBSPECIALTY_ID: 'subspecialty_id',
  NAME_EXACT: 'name__exact',
  SERVICE_ID: 'service_id',
  STATE: 'state',
  CLIENT_SLUG: 'client_slug',
  NPI_IN: 'npi__in',
  ID_IN: 'id__in',
  LOCATION_ID: 'location_id',
  NPI: 'npi',
  PRODUCT_IDS: 'product_ids',
  LOCATION_STATE: 'location_state',
  LOCATION_TIER: 'location_tier',
  FREEFORM: 'freeform',
  HIGHLIGHT: 'highlight',
  HOSPITAL_AFFILIATION: 'hospital_affiliations__in',
  GROUP_AFFILIATION: 'group_affiliations__in',
} as const;

export type FusionParam = (typeof PARAMS)[keyof typeof PARAMS];
